import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import RightContainerDataTh from "../../../../languages/th/offers/rightCompData";
import RightContainerDataEn from "../../../../languages/en/offers/rightCompData";

const RightContainer = ({ language }) => {
  let data = language === "en" ? RightContainerDataEn : RightContainerDataTh;

  return (
    <>
      <h3 className="text-sm  my-5">{data.title}</h3>
      <p className="relative text-3xl font-bold mb-12 text-center text-primary-200">
        {data.price1} <br />
        {data.price2}
        <span
          className="absolute bg-primary-200 text-white w-2.5 h-10 
        top-10 right-4 flex items-center justify-center rounded-lg"
        ></span>
      </p>

      <hr className="border-1 border-gray-300" />

      <p className="text-primary-200 my-2 text-center ">
        {data.secondaryTitle}
      </p>

      <hr className="border-1 border-gray-300 mb-3" />

      {data.details.map((detail, index) => (
        <p className="text-gray-600 mt-2" key={index}>
          {detail.iconType === "FaCheck" && <FaCheck {...detail.iconProps} />}
          {detail.text1 && (
            <span className={`text-${detail.color1}`}>{detail.text1}</span>
          )}
        </p>
      ))}

      <div className="flex flex-col items-center justify-center mt-7">
        <p className="text-primary-200 text-center text-xs mb-4">
          {data.subTitle}
        </p>
        <button
          className="bg-transparent  border-2
         text-primary-100 font-bold py-2 px-4 rounded-full w-3/4"
          onClick={() => window.open("https://lin.ee/ZOIXDQvv", "_blank")}
        >
          {data.btn}
        </button>
      </div>
    </>
  );
};

export default RightContainer;
